import { DataType, MappingFieldDto, PatientDto } from '@lmt/shared-types';
import { nameofFactory } from '@lmt/unicorn-shared/app/helpers/nameof';
import { useCallback } from 'react';

const nameOfPatient = nameofFactory<PatientDto>();

const fieldFilter = ['absence_reason'];

type Row = {
  table: string;
  dictionaryField?: string;
};

/**
 * Filters for dictionary fields (column 'Dictionary field') in mappings table (GDT and HL7)
 * @param queryFields
 */
export const useDictionaryFieldsFilterFunc = (
  queryFields: MappingFieldDto[] | undefined,
) => {
  return useCallback(
    (options: {
      data: {
        table: string;
      };
    }) => {
      return {
        store: queryFields
          ?.filter(
            (x) =>
              x.dataType === DataType.Dictionary &&
              (!x.possibleValues || Object.keys(x.possibleValues).length === 0),
          )
          .sort((a, b) => a.fieldName.localeCompare(b.fieldName)),
        filter: options.data
          ? ['tableName', '=', (options.data as Row).table]
          : null,
      };
    },
    [queryFields],
  );
};

/**
 * Filter for simple fields (column 'Field name') in mappings table (HL7 and GDT)
 * @param queryFields All mapping fields
 * @param tableNames
 */
export const useFieldNamesFilterFunc = (
  queryFields: MappingFieldDto[] | undefined,
  tableNames: string[],
) => {
  return useCallback(
    (options: {
      data: {
        table: string;
        dictionaryField?: string;
      };
    }) => {
      const row = options.data as Row;
      return {
        store: queryFields
          ?.filter((x) =>
            tableNames.includes(x.tableName)
              ? (x.dataType !== DataType.Dictionary ||
                  (x.possibleValues &&
                    Object.keys(x.possibleValues).length > 0)
                ) &&
                !fieldFilter.includes(x.fieldName.toLowerCase())
              : true,
          )
          .sort((a, b) => a.fieldName.localeCompare(b.fieldName)),
        filter: options.data
          ? [
              'tableName',
              '=',
              row.dictionaryField ? row.dictionaryField : row.table,
            ]
          : null,
      };
    },
    [queryFields, tableNames],
  );
};
